
export const HTTP_METHODS = {
    delete: 'DELETE',
    get: 'GET',
    patch: 'PATCH',
    post: 'POST',
    put: 'PUT'
}

export const STATUS_CODE = {
    ok: 200,
    blank: 204,
    badRequest: 400,
    unauthorised: 401,
    forbidden: 403,
    notFound:404,
    internalError: 500,
    badGateway: 502,
    timeout:504
}

export const  ERROR_CODES = {
    timeout: 'ECONNABORTED'
}

export const MESSAGE_LIST_TYPE = ['JOB_DEFINITION','REQUEST_DEFINITION', 'USER_DEFINITION']

